import React, { createContext, useContext } from 'react';
import { RATING_AGENCY_NAME } from '@/finsight/ui/common/components/TopCompanies/constants';
import useTopCompany from './useTopCompanies';

type TopRatingAgenciesContextType = ReturnType<typeof useTopCompany>;

export const TopRatingAgenciesContext = createContext<TopRatingAgenciesContextType>(null);

export const useTopRatingAgenciesContext = () => {
  const context = useContext(TopRatingAgenciesContext);
  if (!context) {
    throw new Error('useTopRatingAgenciesContext must be used within the TopRatingAgenciesContext');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const TopRatingAgencyContextProvider = ({ children }: IProps) => (
  <TopRatingAgenciesContext.Provider value={ useTopCompany({
    serverData: null,
    companyRole: RATING_AGENCY_NAME,
  }) }
  >
    { children }
  </TopRatingAgenciesContext.Provider>
);

export default TopRatingAgencyContextProvider;
